import http from 'apis/config/http-service';
import { Dispatch } from 'redux';
import { LOGIN_USER_FAILURE, LOGIN_USER_SUCCESS, LOGOUT_USER, RE_BUILD_PERMISSIONS } from 'redux/types';
import { LocalStorageKeys } from 'utils/constants';

interface User {
  [key: string]: any;
}

// qsupply/backend returns the user object directly (not wrapped in `{ user }`)
export const getCurrentUser = (newToken?: string) => (dispatch: Dispatch) => {
  http
    .get('api/v1/users/me')
    .then((res: { data: User }) => {
      dispatch({ type: LOGIN_USER_SUCCESS, payload: res.data });

      localStorage.setItem(LocalStorageKeys.cms_user, JSON.stringify(res.data));

      if (newToken) localStorage.setItem(LocalStorageKeys?.access_token, newToken);

      dispatch({
        type: RE_BUILD_PERMISSIONS,
        payload: {
          permissions: {},
          isSuperAdmin: false,
          user: res.data,
        },
      });
    })
    .catch(() => {
      (dispatch as any)(logoutUser());
      dispatch({ type: LOGIN_USER_FAILURE });
    });
};

export const logoutUser = () => (dispatch: Dispatch) => {
  dispatch({ type: LOGOUT_USER });
  localStorage.removeItem(LocalStorageKeys.cms_user);
  localStorage.removeItem(LocalStorageKeys.access_token);
  localStorage.removeItem(LocalStorageKeys.expiredTime);
};
